import {fromJS} from 'immutable'
const initSettingData = {
  
}

const initGetSettingData = fromJS({
  settingName: '',
  settingValue: ''
})

export function settingData(
  state = initSettingData,
  action
) {
  switch (action.type) {
    case "SETTING_FETCH_DATA_SUCCESS":
      return action.dataSetting;
    default:
      return state;
  }
}

export function getSettingData(
  state = initGetSettingData,
  action
) {
  switch (action.type) {
    case "SETTING_GET_DATA_SUCCESS":
      return fromJS(action.dataGetSetting);
    case 'SETTING_ADD_SETTING_NAME_SUCCESS':
      return state.set('settingName', action.settingName)
    case 'SETTING_ADD_SETTING_VALUE_SUCCESS':
      return state.set('settingValue', action.settingValue)
    default:
      return state;
  }
}